// Single import surface for GSAP across the app. Registers plugins once.
// Import gsap/Flip/prefersReduced from HERE only.
import { gsap } from 'gsap'
import { Flip } from 'gsap/Flip'

gsap.registerPlugin(Flip)

// Shared reduced-motion gate for all motion code (SSR-safe).
export const prefersReduced = () =>
  typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false

export { gsap, Flip }
